import React from 'react'
import styled from 'styled-components'
import Media from 'react-media'

import MenuButton from '../MenuButton'

const Wrapper = styled.div`
	.sidebar-header {
		height: 86px;
		background-color: ${props => props.theme.main.bg};
		width: 100%;
		transition: height 0.4s ease;
		text-align: left;
		padding: 0 25px;

		h1 {
			text-transform: uppercase;
			font-weight: 400;
			color: ${props => props.theme.main.hover};
			font-size: 2em;
			line-height: 86px;
			margin: 0;
			transition: opacity 0.4s ease;
		}
	}
`

const SidebarHeader = ({ menuToggled, toggleMenu, title, current, breakpoint }) => (
  <Wrapper>
    <Media query={`(max-width: ${breakpoint}px)`}>
      { matches => matches
        ? <div className={menuToggled ? 'sidebar-header menuToggled' : 'sidebar-header'}>
          <h1>{current}</h1>
          <MenuButton click={toggleMenu} toggled={menuToggled}/>
        </div>
        : <h2>{title}</h2> }
    </Media>
  </Wrapper>
)

export default SidebarHeader


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/sidebar/SidebarHeader.js